import Page from 'src/index';

export default Page;
